import VInput from '@views/base/input.vue';
import VModal from '@views/base/modal.vue';
import VButton from '@views/base/button.vue';
import VScroll from '@views/base/scroll.vue';
import VCheckbox from '@views/base/checkbox.vue';
import VCell from '@views/base/cell.vue';
import VPhoto from '@views/base/photo.vue';
import VPhoto2 from '@views/base/photo2.vue';
import VCounter from '@views/base/counter.vue';

import { getUrlParam, toView, regPhone, regPsw, regAmount } from '@utils/util.js';
import md5 from 'blueimp-md5';
import lrz from 'lrz';

const components = [
  VInput,
  VModal,
  VButton,
  VScroll,
  VCheckbox,
  VCell,
  VPhoto,
  VPhoto2,
  VCounter
];

const funcs = {
  getUrlParam,
  toView,
  regPhone,
  regPsw,
  regAmount,
  md5,
  lrz
};

export default function (Vue) {
  components.map(component => {
    Vue.component(component.name, component);
  });

  Object.keys(funcs).map(key => {
    Vue.prototype[`$${key}`] = funcs[key];
  });
}

// 生产模式开启pwa支持
// if (process.env.NODE_ENV === 'production' && process.env.SW === true) {
//   if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//       navigator.serviceWorker.register('/sw.js').then(registration => {
//         console.log('SW registered: ', registration);
//       }).catch(registrationError => {
//         console.log('SW registration failed: ', registrationError);
//       });
//     });
//   }
// }



// WEBPACK FOOTER //
// ./src/vue-init/init.js